import { makeStyles } from '@fluentui/react-components';

export const useUtilizationTrendChartStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
});
